export enum ENUM__list_mode {
  SCALED_TO_AMOUNT = 'scaled_to_amount',
  ONE_ITEM = 'one_item',
}
